<template>
    <div class="page">
        <div class="page-header" v-if="!!structure">
            <h4>
                {{ structure.name }} ({{
                    !!structure.structure_type
                        ? structure.structure_type.name
                        : ''
                }})
            </h4>
        </div>
        <button class="btn btn-secondary" @click="back">
            <i class="fa fa-arrow-left fa-lg" aria-hidden="true"></i>
        </button>
        <div class="alert alert-warning" v-if="!vehicles.length">
            No hay vehículos asociados a la estructura
        </div>
        <div class="table-responsive" v-if="!!vehicles.length">
            <table
                class="table table-sm table-hover table-bordered table-striped"
            >
                <thead class="thead-orange">
                    <tr>
                        <th>Placa</th>
                        <th>Marca</th>
                        <th>Tipo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="vehicle in vehicles">
                        <td>{{ vehicle.plate }}</td>
                        <td>{{ vehicle.brand }}</td>
                        <td>{{ vehicle.vehicle_type.name }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import structuresRepository from '../../../repositories/structures.repository'
export default {
    props: ['structureId'],
    data() {
        return {
            structure: '',
            isAdminClient: false,
        }
    },
    methods: {
        loadStructure() {
            const sr = Object.assign({}, structuresRepository)
            sr.byId(this.structureId)
                .then(data => (this.structure = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los vehículos asociados a la estructura'
                    )
                )
        },
        back() {
            if (this.isAdminClient) {
                this.$router.push({
                    name: 'listStructuresAdminClient',
                    params: { preselectedClientId: this.structure.client_id },
                })
            } else {
                this.$router.push({
                    name: 'listStructures',
                    params: { preselectedClientId: this.structure.client_id },
                })
            }
        },
    },
    computed: {
        vehicles() {
            return !!this.structure && !!this.structure.vehicles.length
                ? this.structure.vehicles
                : []
        },
    },
    created() {
        this.loadStructure()
        this.isAdminClient =
            this.user.profile.slug === 'cliente-admin' ? true : false
    },
}
</script>
